export default "__VITE_ASSET__BxkNUTT2__"